{
  "formName": "Create Document Invoice",
  "formRows": [
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "invoiceDate",
            "displayLabel": "Billing Date",
            "disabled": false,
            "placeHolder": "Select Billing Date",
            "fieldInfo": {
              "dataType": "date",
              "defaultToCurrentDate": true,
              "dateConfigs": {
                "maxRangeFromCurrent": 1,
                "maxRangeUnit": "years",
                "minRangeFromCurrent": -1,
                "minRangeUnit": "years"
              }
            },
            "permissionConditions": {
              "readOnly": {
                "type": "any",
                "permissionIds": [
                  "FIELD_INVOICES_EDIT_BILLING_DATE"
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Billing Date is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "validTill",
            "displayLabel": "Valid Till",
            "disabled": false,
            "placeHolder": "Select Validity Date",
            "fieldInfo": {
              "dataType": "date"
            },
            "validators": [
              {
                "type": "required",
                "message": "Valid Till is required"
              }
            ]
          }
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "documentType",
            "displayLabel": "Document Type",
            "disabled": false,
            "placeHolder": "Select Document Type",
            "fieldInfo": {
              "dataType": "select",
              "options": [
                {
                  "label": "IGM Item Number",
                  "value": "IGM_ITEM_NUMBER"
                },
                {
                  "label": "BOE Number",
                  "value": "BOE_NUMBER"
                },
                {
                  "label": "Shipping Bill Number",
                  "value": "SHIPPING_BILL_NUMBER"
                },
                {
                  "label": "Ex BOE Number",
                  "value": "EXBOE_NUMBER"
                }
              ],
              "displayKey": "label",
              "valueKey": "value"
            },
            "validators": [
              {
                "type": "required",
                "message": "Document Type is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "documentNumber",
            "displayLabel": "Document Number",
            "disabled": false,
            "placeHolder": "Select Document Number",
            "fieldInfo": {
              "dataType": "picklist"
            },
            "conditions": {
              "visibility": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "documentType",
                    "operator": "NOT_EQUALS",
                    "value": "CONTAINER_NUMBER"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Document Number is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "containerId",
            "displayLabel": "Container Number",
            "disabled": false,
            "placeHolder": "Select Container Number",
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/containers/list",
                "filterByKeys": [
                  "CONTAINER_NO_CONTAINS"
                ],
                "limit": 10,
                "orderBy": {
                  "containerNo": "asc"
                },
                "bindLabel": "containerNo",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "containerNo",
                    "header": "Container Number"
                  },
                  {
                    "key": "containerSize",
                    "header": "Size"
                  },
                  {
                    "key": "containerType",
                    "header": "Type"
                  }
                ]
              }
            },
            "conditions": {
              "visibility": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "documentType",
                    "operator": "EQUALS",
                    "value": "CONTAINER_NUMBER"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "autocompleteRequired",
                "message": "Container Number is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "cycle",
            "displayLabel": "Cycle",
            "disabled": false,
            "hidden": true,
            "placeHolder": "Select Cycle",
            "fieldInfo": {
              "dataType": "select",
              "options": [
                {
                  "label": "Import",
                  "value": "IMPORT"
                },
                {
                  "label": "Export",
                  "value": "EXPORT"
                }
              ]
            },
            "validators": [
              {
                "type": "selectRequired",
                "message": "Cycle is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "customerId",
            "displayLabel": "Customer",
            "disabled": true,
            "placeHolder": "Select Customer",
            "returnRawValue": true,
            "fieldInfo": {
              "dataType": "picklist",
              "options": [],
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Customer is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "billingPartyId",
            "displayLabel": "Billing Party",
            "disabled": false,
            "placeHolder": "Select Billing Party",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "options": [],
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": [
                      "true"
                    ]
                  }
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  },
                  {
                    "key": "code",
                    "header": "Code"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "autocompleteRequired",
                "message": "Billing Party is required"
              }
            ]
          }
        }
      ]
    },
    {
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "billingAddressId",
            "displayLabel": "Billing Address",
            "disabled": false,
            "placeHolder": "Enter Billing Address",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "select",
              "options": [],
              "returnRawValue": false
            },
            "conditions": {
              "disabled": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "billingPartyId",
                    "operator": "EQUALS",
                    "value": null
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Billing Address is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "chargeGroupId",
            "displayLabel": "Charge Group",
            "disabled": false,
            "placeHolder": "Select Charge Group",
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/charge-groups/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "filterByKey": "name",
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Charge Group is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "paymentTerm",
            "displayLabel": "Payment Term",
            "disabled": false,
            "placeHolder": "Select Payment Term",
            "fieldInfo": {
              "dataType": "select",
              "options": [
                {
                  "label": "Cash",
                  "value": "CASH"
                },
                {
                  "label": "Credit",
                  "value": "CREDIT"
                },
                {
                  "label": "PDA",
                  "value": "PDA"
                }
              ]
            },
            "validators": [
              {
                "type": "required",
                "message": "Payment Term is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "payingPartyId",
            "displayLabel": "Paying Party",
            "disabled": false,
            "placeHolder": "Select Paying Party",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": [
                      "true"
                    ]
                  }
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  },
                  {
                    "key": "code",
                    "header": "Code"
                  }
                ]
              }
            },
            "conditions": {
              "visibility": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "paymentTerm",
                    "operator": "EQUALS",
                    "value": "PDA"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Paying Party is required"
              }
            ]
          }
        }
      ]
    }
  ],
  "accordionTableData": {
    "headers": [
      {
        "fieldName": "inventoryId",
        "displayName": "Container ID",
        "hidden": true
      },
      {
        "fieldName": "inventoryNo",
        "displayName": "Container Number"
      },
      {
        "fieldName": "containerSize",
        "displayName": "Size"
      },
      {
        "fieldName": "containerType",
        "displayName": "Type"
      },
      {
        "fieldName": "gateInDate",
        "displayName": "Gate In Date",
        "dataType": "DATE"
      },
      {
        "fieldName": "stuffDate",
        "displayName": "Stuffing Date",
        "dataType": "DATE"
      },
      {
        "fieldName": "destuffDate",
        "displayName": "Destuffing Date",
        "dataType": "DATE"
      },
      {
        "fieldName": "gateOutDate",
        "displayName": "Gate Out Date",
        "dataType": "DATE"
      },
      {
        "fieldName": "totalPackages",
        "displayName": "NOP"
      },
      {
        "fieldName": "grossWeight",
        "displayName": "Gross Weight"
      },
      {
        "fieldName": "importType",
        "displayName": "Import Type"
      },
      {
        "fieldName": "storageDays",
        "displayName": "No of Days"
      },
      {
        "fieldName": "amount",
        "displayName": "Charge Amount"
      },
      {
        "fieldName": "rebateAmount",
        "displayName": "Rebate Amount"
      },
      {
        "fieldName": "discount",
        "displayName": "Discounted Amount"
      },
      {
        "fieldName": "taxableAmount",
        "displayName": "Taxable Amount"
      },
      {
        "fieldName": "cgst",
        "displayName": "CGST"
      },
      {
        "fieldName": "sgst",
        "displayName": "SGST"
      },
      {
        "fieldName": "igst",
        "displayName": "IGST"
      },
      {
        "fieldName": "totalAmount",
        "displayName": "Total Amount"
      }
    ],
    "data": []
  },
  "documentAccordionTableData": {
    "headers": [
      {
        "fieldName": "inventoryId",
        "displayName": "Document ID",
        "hidden": true
      },
      {
        "fieldName": "inventoryNo",
        "displayName": "Document Number"
      },
      {
        "fieldName": "documentType",
        "displayName": "Document Type"
      },
      {
        "fieldName": "storageDays",
        "displayName": "No of Days"
      },
      {
        "fieldName": "destuffingDate",
        "displayName": "Destuffing Date",
        "dataType": "DATE"
      },
      {
        "fieldName": "stuffingDate",
        "displayName": "Stuffing Date",
        "dataType": "DATE"
      },
      {
        "fieldName": "weight",
        "displayName": "Total Weight"
      },
      {
        "fieldName": "totalArea",
        "displayName": "Total Area"
      },
      {
        "fieldName": "amount",
        "displayName": "Charge Amount"
      },
      {
        "fieldName": "rebateAmount",
        "displayName": "Rebate Amount"
      },
      {
        "fieldName": "discount",
        "displayName": "Discounted Amount"
      },
      {
        "fieldName": "taxableAmount",
        "displayName": "Taxable Amount"
      },
      {
        "fieldName": "cgst",
        "displayName": "CGST"
      },
      {
        "fieldName": "sgst",
        "displayName": "SGST"
      },
      {
        "fieldName": "igst",
        "displayName": "IGST"
      },
      {
        "fieldName": "totalAmount",
        "displayName": "Total Amount"
      }
    ],
    "data": []
  }
}
